import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { FaUser, FaDoorOpen, FaConnectdevelop, FaCode, FaClipboardList, FaDiscord } from "react-icons/fa6";
import Card from "@components/ui/Card/Card";
import Button from "@components/forms/Button/Button";
import UserService from "@services/UserService";
import { disconnectUser } from "@slices/userSlice";

function SettingsPage() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleLogout = () => {
        const userService = new UserService;
        const promise = userService.logout();

        toast.promise(promise, {
            loading: t('toast.disconnecting'),
            success: () => t('toast.disconnected'),
            error: err => err.body.message || t('toast.error_fetching'),
        });

        promise.then(() => {
            dispatch(disconnectUser());
            navigate('/');
        });
    };

    return (
        <div className="gx-0 row">
            <div className="col-12 col-lg-4 p-3">
                <h1>{t('page.settings.title.profile')}</h1>

                <Card>
                    <div className="row g-2">
                        <div className="col-12">
                            <Button filled textAlign="left" onClick={() => navigate('/settings/account')}><FaUser size="1rem"/> {t('page.settings.button.my_account')}</Button>
                        </div>
                        <div className="col-12">
                            <Button filled className="red" textAlign="left" onClick={handleLogout}><FaDoorOpen size="1rem"/> {t('page.settings.button.logout')}</Button>
                        </div>
                    </div>
                </Card>
            </div>

            <div className="col-12 col-lg-4 p-3">
                <h1>{t('page.settings.title.apis')}</h1>

                <Card>
                    <div className="row g-2">
                        <div className="col-12">
                            <Button filled textAlign="left" onClick={() => navigate('/settings/apis')}><FaConnectdevelop size="1rem"/>{t('page.settings.button.external_apis')}</Button>
                        </div>
                        <div className="col-12">
                            <Button filled textAlign="left" onClick={() => navigate('/settings/developer')} disabled><FaCode size="1rem"/>{t('page.settings.button.developers')}</Button>
                        </div>
                    </div>
                </Card>
            </div>

            <div className="col-12 col-lg-4 p-3">
                <h1>{t('page.settings.title.lumeba')}</h1>

                <Card>
                    <div className="row g-2">
                        <div className="col-12">
                            <Button filled textAlign="left" onClick={() => navigate('/changelog')}><FaClipboardList size="1rem"/>{t('page.settings.button.changelog')}</Button>
                        </div>
                        <div className="col-12">
                            <Button filled textAlign="left"><FaDiscord size="1rem"/>{t('page.settings.button.join_discord')}</Button>
                        </div>
                    </div>
                </Card>
            </div>
        </div>
    );
}

export default SettingsPage;
